export default "__VITE_ASSET__C$GivSXl__"